




















import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import { mediaUrlFallback } from '@/helpers/utils';

export type UspType = {
  media_path: string;
  title: string;
  url: string;
  html: string;
};

export default defineComponent({
  name: 'BuySectionUsps',
  props: {
    usps: {
      type: Array as PropType<UspType[]>,
      required: true,
      default: () => []
    }
  },
  setup() {
    const activeUsp = ref<UspType | null>(null);

    const handleUspClick = (usp: UspType) => {
      if (!usp.html) return;
      activeUsp.value = usp;
    };

    return {
      activeUsp,
      mediaUrlFallback,
      handleUspClick
    };
  }
});
